import { loadable } from '@appclose/core';

const SignInPageAsync = loadable(() => import('./index'));

export default SignInPageAsync;
